module.exports = __webpack_public_path__ + "img/695.a9da11a8.jpg";